"use client";

import useInterval from "@hudson/ui/lib/use_interval";
import Session from "@lib/session";
import router from "next/router";

export default function CheckForSessionExpiration() {
  // Check expirations every 20 seconds.
  useInterval(() => {
    if (Session.isExpired(1)) {
      // Silence isExpired()'s cookie leg before the async teardown, same as
      // Session.get/set's expiry branch: without this, a logout call that never
      // lands leaves the expired cookie in place and this interval re-runs the
      // full teardown (detach mutation + store reset) every 20 seconds.
      Session.clearAuthCookies();
      Session.clearSession();
      if (router.pathname.includes("/book"))
        router.replace(`/${router.query.siteId}/book?session_expired=1`);
    }
  }, 20000);

  return null;
}
